// extracted by mini-css-extract-plugin
export default {"logoContainer":"topbar-menu_logoContainer__bvys5","logo":"topbar-menu_logo__gTJBO","container":"topbar-menu_container__M0Sq2"};